import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconTriangleDown = props => {
  if (props.id !== "_svgicontriangledown") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path fill="#384048" d="M24 28l6-8H18z" /></g></svg>;
};

SvgIconTriangleDown.displayName = "_svgicontriangledown";
SvgIconTriangleDown.propTypes = {
  id: PropTypes.string
};
SvgIconTriangleDown.defaultProps = {
  id: ''
};
export default SvgIconTriangleDown;